import React from "react";

import { useAdminPreview } from "#/contexts/AdminPreviewContext";

export function PreviewBanner() {
  const { preview } = useAdminPreview();

  if (!preview) {
    return null;
  }

  return (
    <div className="flex items-center gap-x-6 bg-destructive text-destructive-foreground px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm leading-6">
        <strong className="font-semibold">
          Você está visualizando uma prévia dessa página.{" "}
        </strong>
        Ela ainda não está publicada.{" "}
      </p>
      <div className="flex flex-1 justify-end"></div>
    </div>
  );
}
